<template>
    <v-card-text class="pt-0 ps-0">
        <v-row>
            <v-col class="text-right">
                <v-icon @click="dialog = true" color="primary">mdi-brush-outline</v-icon>
            </v-col>
            <!--<v-col class="pa-0">-->
            <!-- Button group to toggle between Horizontal and Vertical views -->
            <!--<v-btn-toggle v-model="selectedChart" class="my-4" mandatory shaped>
                <v-btn value="chart4">{{$t('ChartFour')}}</v-btn>
            </v-btn-toggle>
        </v-col>-->
        </v-row>
        <!--<v-container>
            <v-row>
                <v-col md="6" cols="12">-->
                    <!-- Filter by Year -->
                    <!--<v-menu v-model="yearMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field hide-details v-model="selectedYear" outlined clearable dense
                                          :label="$t('Year')"
                                          readonly
                                          v-bind="attrs" @input="selectYear($event)"
                                          v-on="on"></v-text-field>
                        </template>
                        <v-date-picker :max="maxDate"
                                       type="year" @click:year="selectYear($event)"></v-date-picker>
                    </v-menu>

                </v-col>
                <v-col md="6" cols="12">-->
                    <!-- Filter by Quarter (using Calendar) -->
                    <!--<v-select hide-details v-model="selectedQuarter" @input="selectQuarter($event)" clearable outlined dense
                              :items="quarters"
                              :label="$t('Quarter')"></v-select>
                </v-col>
            </v-row>
        </v-container>-->
        <v-dialog v-model="dialog" persistent max-width="500px">
            <v-card>
                <div class="card-title">
                    {{ $t('ChangeColor')}}
                </div>
                <v-card-title></v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="6">
                            <v-color-picker v-model="maleColor"
                                            mode="hexa"
                                            label="Male Color"></v-color-picker>
                        </v-col>
                        <v-col cols="6">
                            <v-color-picker v-model="femaleColor"
                                            mode="hexa"
                                            label="Female Color"></v-color-picker>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="dialog = false" text>{{$t('Close')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Horizontal layout -->
        <v-row v-if="value.length>0" style="margin: auto; margin-right: 10px; margin-top: 0px;">
            <v-col>
                <v-card class="elevation-0" style="background-color: #efeded; border-radius: 15px;">

                    <v-card-text class="d-flex align-center justify-space-around">
                        <v-container>
                            <v-row>
                                <v-col cols="6" v-for="(item, index) in value" :key="index" class="text-center" @click="filterQuestionOption(item)">
                                    <img :src="item.name == 'male' || item.name == 'ذكر'?'/maleone.png':'/femaleone.png'" style="max-width:100%;margin:auto; height:100px" /><br />
                                    <span v-if="value" style="font-size: 21px; color: #000;">{{item.name}}</span><br />
                                    <span :style="{ color: item.name == 'male' || item.name == 'ذكر'?maleColor:femaleColor, fontSize: '21px' }">{{ item.value }}%</span><br />
                                    <!--<span :style="{ color: item.name == 'male' || item.name == 'ذكر'?maleColor:femaleColor, fontSize: '21px' }">{{ item.count }}</span><br />-->
                                    
                                </v-col>
                                
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-card-text>
</template>

<script>
    export default {
        props: {
            value: {
                type: Array,
                default: () => [],
            },
            quarters: {
                type: Array,
                default: () => [],
            },
            q: undefined
        },
        data() {
            return {
                selectedChart: 'chart1', // Default to horizontal view
                maleColor: '#36A1AA', // Default male color
                femaleColor: '#EC88E0', // Default female color
                dialog:false,
                yearMenu: false,
                quarterMenu: false,
                selectedYear: null,
                selectedQuarter: null,
                maxDate: new Date().toISOString().split('T')[0],
            }
        },
        computed: {
            femaleCount() {
                return Math.floor(10 * this.value[1].value / 100)
            },
            maleCount() {
                return Math.floor(10 * this.value[0].value / 100)
            }
        },
        methods: {
            selectYear(year) {
                this.selectedYear = year
                this.yearMenu = false
                this.yearPicker = null
                this.$emit('selectGenderYear', year)
            },
            selectQuarter(quarter) {
                this.$emit('selectGenderQuarter', quarter)
            },
            filterQuestionOption(item) {
                this.$emit('filterQuestionOption', item, this.q, this.value)
            }
        }
    }
</script>

<style scoped>
</style>
